<template>
  <div class="share-money background-gradient">
    <div class="header">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('Share & Earn') }}</h1>
      <div class="header-right"></div>
    </div>
    
    <div class="content">
      <div class="promotion-section">
        <div class="invite-container">
          <div class="invite-header-row">
            <div class="invite-header">
              <h3>{{ $t('Invite Link') }}</h3>
            </div>
            
            <div class="invite-stats">
              <div class="invite-stat-item">
                <span class="stat-label">{{ $t('Direct Invites') }}</span>
                <span class="stat-value">{{ stats.directAgents || 0 }} {{ $t('people') }}</span>
              </div>
            </div>
          </div>
          
          <div class="invite-link-box">
            <input type="text" :value="normalLink" readonly class="invite-link-input">
            <button class="copy-btn" @click="copyLink('normal')">
              {{ $t('Copy') }}
            </button>
          </div>
          
          <div class="invite-qr-code">
            <div class="qr-code-wrapper">
              <img :src="qrCodeUrl" alt="QR Code" class="qr-code-image" ref="qrCodeImage">
            </div>
            <button class="save-qr-btn" @click="saveQRCode">{{ $t('Save to Album') }}</button>
          </div>
        </div>
      </div>
      
      <div class="tier-rewards-section">
        <div class="section-title">
          <span class="section-icon">{{ $t('Tiered Rewards') }}</span>
          <span class="section-note">{{ $t('Invite valid subordinates to claim rewards at each tier') }}</span>
        </div>
        
        <div class="tier-rewards-grid">
          <div v-for="reward in tierRewards" :key="reward.tier" class="tier-reward-card" 
               :class="{ 
                 'can-claim': stats.totalAgents >= reward.inviteCount && !reward.claimed,
                 'claimed': reward.claimed
               }">
            <div class="reward-icon">
              <img v-if="reward.claimed" :src="getRewardIcon('claimed')" alt="Claimed" class="icon-image">
              <img v-else-if="stats.totalAgents >= reward.inviteCount" :src="getRewardIcon('can-claim')" alt="Can Claim" class="icon-image">
              <img v-else :src="getRewardIcon('locked')" alt="Locked" class="icon-image">
            </div>
            <div class="invite-count">{{ $t('Invite') }}{{ reward.inviteCount }}{{ $t('people') }}</div>
        
            <div class="reward-amount">
              <span class="currency">{{ currencySymbol }}</span>
              <span class="amount">{{ reward.reward | vnd }}</span>
            </div>
            <button class="claim-btn" 
                    @click="claimTierReward(reward.tier)"
                    :disabled="reward.claimed || stats.totalAgents < reward.inviteCount">
              {{ reward.claimed ? $t('Claimed') : (stats.totalAgents >= reward.inviteCount ? $t('Claim') : $t('Unfulfilled')) }}
            </button>
          </div>
        </div>
      </div>
      
      <div class="promotion-section">
        <div class="invite-container">
          <div class="invite-header">
            <h3>{{ $t('Invitation Rules') }}</h3>
          </div>
          <div class="invite-stats rules-box">
            <p class="rule-text">{{ $t('Invite real and valid subordinates who recharge a cumulative amount of 500 or more to claim the corresponding rewards.').replace('VND', currencyCode) }}</p>
            <p class="rule-text">{{ $t('For example: Invite 1 valid subordinate + cumulative recharge of 500 to claim the tier 1 bonus!').replace('VND', currencyCode) }}</p>
            <p class="rule-text warning">{{ $t('Attention! Using multiple IPs to fake subordinates for rewards is prohibited. Our anti-arbitrage system will permanently ban the sharing function and freeze sharing rewards if arbitrage is detected!') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shareMoney',
  data() {
    return {
      normalLink: 'https://aa451...',
      wechatLink: 'http://7lb-7dwo...',
      rebateData: {
        daily: 0,
        weekly: 0,
        monthly: 0
      },
      currentSlide: 0, 
      slideInterval: null,
      tierRewards: [],
      currentInviteCount: 0, 
      directInvites: 0, 
      validInvites: 0, 
      inviteCode: '', 
      qrCodeUrl: '', 
      stats: {
        totalMembers: 0,
        totalAgents: 0,
        directMembers: 0,
        directAgents: 0
      }
    };
  },
  created() {
    // 先用本站域名生成二维码，避免接口失败时显示破图
    this.normalLink = window.location.origin + '/#/';
    this.qrCodeUrl = this.generateQrCodeUrl();
    this.getShareInfo();
    this.getTeamStats();
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  },
  methods: {
    getRewardIcon(type) {
      const icons = {
        'locked': '/static/style/baulock.png',
        'can-claim': '/static/style/bauliberado.png',
        'claimed': '/static/style/bauaberto.png'
      };
      return icons[type] || '';
    },
    getShareInfo() {
      let that = this;
      this.$apiFun.post('/api/tier-rewards', {}).then(res => {
        if (res.code === 200 && res.data) {
          that.tierRewards = res.data.rewards || [];
          that.currentInviteCount = typeof res.data.currentInviteCount !== 'undefined' ? res.data.currentInviteCount : 0;
          that.directInvites = typeof res.data.directInvites !== 'undefined' ? res.data.directInvites : 0;
          that.validInvites = typeof res.data.validInvites !== 'undefined' ? res.data.validInvites : 0;
        }
      }).catch(err => {
        console.error('Error fetching tier rewards:', err);
      });
      
      this.$apiFun.get('/api/share/info').then(res => {
        if (res.code === 200) {
          that.normalLink = res.data.normalLink || that.normalLink;
          that.wechatLink = res.data.wechatLink || that.wechatLink;
          that.rebateData = res.data.rebateData || that.rebateData;
          that.inviteCode = res.data.inviteCode || 'PEMW88DUN';
          that.qrCodeUrl = res.data.qrCodeUrl || that.generateQrCodeUrl();
        }
      }).catch(err => {
        console.error('Error fetching share info:', err);
        const userId = localStorage.getItem('userId') || '1';
        that.normalLink = window.location.origin + '/#/register?pid=' + userId;
        that.wechatLink = window.location.origin + '/#/register?pid=' + userId + '&channel=wechat';
        that.inviteCode = 'PEMW88DUN';
        that.qrCodeUrl = that.generateQrCodeUrl();
      });
    },
    generateQrCodeUrl() {
      const encodedUrl = encodeURIComponent(this.normalLink);
      return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodedUrl}`;
    },
    saveQRCode() {
      const img = this.$refs.qrCodeImage;
      if (!img) {
        alert(this.$t('QR code image does not exist'));
        return;
      }
      
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 300;
      const ctx = canvas.getContext('2d');
      
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      const imgWidth = 280;
      const imgHeight = 280;
      const imgX = (canvas.width - imgWidth) / 2;
      const imgY = (canvas.height - imgHeight) / 2;
      
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        ctx.drawImage(image, imgX, imgY, imgWidth, imgHeight);
        canvas.toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'qrcode.png';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          alert(this.$t('QR code saved to album'));
        });
      };
      image.onerror = () => {
        alert(this.$t('Failed to save QR code, please try again'));
      };
      image.src = img.src;
    },
    copyInviteCode() {
      const input = document.createElement('input');
      input.value = this.inviteCode || 'PEMW88DUN';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert(this.$t('Invitation code copied'));
    },
    getTeamStats() {
      let that = this;
      const getFromPerformance = () => {
        that.$apiFun.post('/agent/index/getPerformance').then(res => {
          if (res.code === 200 && res.data) {
            that.stats = {
              totalMembers: res.data.totalMembers || 0,
              totalAgents: res.data.totalAgents || 0,
              directMembers: res.data.directMembers || 0,
              directAgents: res.data.directAgents || 0
            };
            that.directInvites = res.data.directAgents || 0;
            that.currentInviteCount = res.data.totalAgents || 0;
            that.validInvites = res.data.totalAgents || 0;
          } else {
            getFromApiTeamPerformance();
          }
        }).catch(err => {
          getFromApiTeamPerformance();
        });
      };

      const getFromApiTeamPerformance = () => {
        that.$apiFun.get('/api/team/performance').then(res => {
          if (res.code === 200) {
            that.stats = {
              totalMembers: res.data.totalMembers || 0,
              totalAgents: res.data.totalAgents || 0,
              directMembers: res.data.directMembers || 0,
              directAgents: res.data.directAgents || 0
            };
            that.directInvites = res.data.directAgents || 0;
            that.currentInviteCount = res.data.totalAgents || 0;
            that.validInvites = res.data.totalAgents || 0;
          } else {
            getStatsFromMembers();
          }
        }).catch(err => {
          getStatsFromMembers();
        });
      };

      const getStatsFromMembers = () => {
        that.$apiFun.post('/agent/index/getChildList').then(res => {
          if (res.code === 200 && res.data && res.data.data) {
            const members = res.data.data;
            const directMembers = members.filter(member => member.is_direct === 1).length;
            const totalAgents = members.filter(member => member.is_agent === 1).length;
            const directAgents = members.filter(member => member.is_agent === 1 && member.is_direct === 1).length;
            
            that.stats = {
              totalMembers: members.length,
              totalAgents: totalAgents,
              directMembers: directMembers,
              directAgents: directAgents
            };
            that.directInvites = directAgents;
            that.currentInviteCount = totalAgents;
            that.validInvites = totalAgents;
          }
        }).catch(err => {});
      };

      getFromPerformance();
    },
    shareToSocial(platform) {
      const url = this.normalLink;
      const text = this.$t('Come and join us!');
      switch (platform) {
        case 'facebook':
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
          break;
        case 'twitter':
          window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank');
          break;
        case 'whatsapp':
          window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
          break;
        case 'telegram':
          window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank');
          break;
        case 'instagram':
          alert(this.$t('Please share to Instagram manually'));
          break;
        default:
          break;
      }
    },
    copyLink(type) {
      const link = type === 'normal' ? this.normalLink : this.wechatLink;
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert(this.$t('Link copied'));
    },
    startCarousel() {
      this.slideInterval = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    nextSlide() {
      const slides = document.querySelectorAll('.banner-slide');
      const dots = document.querySelectorAll('.banner-dot');
      if (slides.length === 0 || dots.length === 0) return;
      slides[this.currentSlide].style.display = 'none';
      dots[this.currentSlide].classList.remove('dot-active');
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      slides[this.currentSlide].style.display = 'block';
      dots[this.currentSlide].classList.add('dot-active');
    },
    claimTierReward(tier) {
      const reward = this.tierRewards.find(r => r.tier === tier);
      if (!reward) {
        alert(this.$t('Reward does not exist!'));
        return;
      }
      if (reward.claimed) {
        alert(this.$t('This reward has already been claimed!'));
        return;
      }
      if (this.stats.totalAgents < reward.inviteCount) {
        alert(this.$t('You need to invite') + ' ' + (reward.inviteCount - this.stats.totalAgents) + this.$t('more subordinate agents to claim this reward!'));
        return;
      }
      
      this.$apiFun.post('/api/claim-tier-reward', { tier: tier }).then(res => {
        if (res.code === 200) {
          reward.claimed = true;
          alert(this.$t('Congratulations! Successfully claimed tier') + tier + this.$t('reward of') + reward.reward + ' ' + this.currencyCode + '!');
        } else {
          alert(res.msg || this.$t('Failed to claim reward, subordinates do not meet the requirements!'));
        }
      }).catch(err => {
        alert(this.$t('Failed to claim reward, subordinates do not meet the requirements!'));
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 白底棕金主题 */
.background-gradient {
  background: #ffffff;
  min-height: 100vh;
  box-sizing: border-box;
  color: #352b24;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #a86329, #7b451a);
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(117, 73, 34, 0.18);
  
  .back {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    
    i {
      font-size: 20px;
      color: #fff;
    }
  }
  
  h1 {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin: 0;
    letter-spacing: 1px;
  }
  
  .header-right {
    width: 44px;
  }
}

.content {
  padding-top: 70px;
  padding-bottom: 40px;
  max-width: 600px;
  margin: 0 auto;
}

.promotion-section, .tier-rewards-section {
  background-color: #ffffff;
  margin: 0 15px 20px;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 5px 18px rgba(117, 73, 34, 0.08);
  border: 1px solid #eadfd3;
}

.invite-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  .invite-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    color: #352b24;
  }
  
  .invite-stats .stat-label {
    font-size: 14px;
    color: #8a6a4a;
  }
  
  .invite-stats .stat-value {
    font-size: 15px;
    font-weight: bold;
    color: #8f501f;
    margin-left: 8px;
  }
}

.invite-link-box {
  display: flex;
  background: #fff8ef;
  border-radius: 8px;
  border: 1px solid #ead1b2;
  margin-bottom: 25px;
  overflow: hidden;
  
  .invite-link-input {
    flex: 1;
    background: transparent;
    border: none;
    color: #352b24;
    padding: 12px 15px;
    font-size: 14px;
    outline: none;
  }
  
  .copy-btn {
    background: linear-gradient(135deg, #fceb99, #d1a03e);
    color: #8c5a1c;
    border: none;
    padding: 0 20px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    transition: filter 0.3s;
    
    &:hover {
      filter: brightness(1.05);
    }
  }
}

.invite-qr-code {
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .qr-code-wrapper {
    background: #ffffff;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(209, 160, 62, 0.2);
    border: 2px solid #d1a03e;
    margin-bottom: 15px;
  }
  
  .qr-code-image {
    width: 140px;
    height: 140px;
    display: block;
  }
  
  .save-qr-btn {
    padding: 8px 24px;
    background: #fff8ef;
    border: 1px solid #d9b98f;
    border-radius: 20px;
    color: #8f501f;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      background: #fff2df;
      color: #744016;
    }
  }
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eadfd3;
  
  .section-icon {
    font-size: 18px;
    font-weight: bold;
    color: #352b24;
  }
  
  .section-note {
    font-size: 12px;
    color: #8a6a4a;
    margin-left: auto;
  }
}

.tier-rewards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.tier-reward-card {
  background: #fffaf3;
  border: 1px solid #ead1b2;
  border-radius: 12px;
  padding: 15px 10px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  
  .reward-icon {
    width: 45px;
    height: 45px;
    margin: 0 auto 10px auto;
    
    .icon-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  
  .invite-count {
    font-size: 12px;
    color: #8a6a4a;
    margin-bottom: 8px;
  }
  
  .reward-amount {
    margin-bottom: 12px;
    
    .currency {
      font-size: 12px;
      color: #b87333;
      font-weight: 600;
    }
    
    .amount {
      font-size: 20px;
      font-weight: bold;
      color: #8f501f;
    }
  }
  
  .claim-btn {
    width: 100%;
    padding: 6px 0;
    border: none;
    border-radius: 15px;
    font-size: 12px;
    font-weight: bold;
    background: #ece4d8;
    color: #a89888;
    cursor: not-allowed;
  }
  
  &.can-claim {
    border-color: #d1a03e;
    box-shadow: 0 0 10px rgba(209, 160, 62, 0.18);
    
    .claim-btn {
      background: linear-gradient(135deg, #fceb99, #d1a03e);
      color: #8c5a1c;
      cursor: pointer;
      animation: pulse-gold 2s infinite;
    }
  }
  
  &.claimed {
    opacity: 0.7;
    border-color: #eadfd3;
    
    .reward-amount .currency,
    .reward-amount .amount {
      color: #a89888;
    }
  }
}

.rules-box {
  .rule-text {
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 10px;
    color: #5c3a12;
    
    &.warning {
      color: #c0392b;
      font-weight: 500;
      margin-top: 15px;
      padding: 12px;
      background: rgba(255, 107, 107, 0.08);
      border-radius: 8px;
      border: 1px solid rgba(255, 107, 107, 0.25);
    }
  }
}

@keyframes pulse-gold {
  0% { box-shadow: 0 0 0 0 rgba(209, 160, 62, 0.5); }
  70% { box-shadow: 0 0 0 6px rgba(209, 160, 62, 0); }
  100% { box-shadow: 0 0 0 0 rgba(209, 160, 62, 0); }
}
</style>



// WEBPACK FOOTER //
// src/components/shareMoney.vue